<template>
  <v-container class="mt-0 pt-0" fluid>
    <v-row>
      <v-flex>
        <navbar></navbar>
      </v-flex>
    </v-row>

    <v-row class="justify-center">
      <div>
        <p class="changefont">Drink</p>
      </div>
    </v-row>

    <!-- start 1 -->
    <v-row class="justify-center my-5">
      <v-flex lg6 md6 sm10 xs10>
        <div class="white--text drinkfont">Hot Beverages</div>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg6 md8 sm12 xs12>
        <v-card>
          <v-container class="py-0 px-0" fluid>
            <v-row>
              <v-col
                v-for="document in Documents1()"
                :key="document.data().imageUrl"
                class="d-flex child-flex"
                cols="12"
              >
                <v-card flat tile>
                  <v-img
                    :src="document.data().imageUrl"
                    :lazy-src="document.data().imageUrl"
                    contain
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-flex>
    </v-row>
    <!-- end -->

    <!-- start 2 -->
    <v-row class="justify-center my-5">
      <v-flex lg6 md6 sm10 xs10>
        <div class="white--text drinkfont">Cold Beverages</div>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg6 md8 sm12 xs12>
        <v-card>
          <v-container class="py-0 px-0" fluid>
            <v-row>
              <v-col
                v-for="document in Documents2()"
                :key="document.data().imageUrl"
                class="d-flex child-flex"
                cols="12"
              >
                <v-card flat tile>
                  <v-img
                    :src="document.data().imageUrl"
                    :lazy-src="document.data().imageUrl"
                    contain
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-flex>
    </v-row>
    <!-- end -->

    <!-- start 3 -->
    <v-row class="justify-center my-5">
      <v-flex lg6 md6 sm10 xs10>
        <div class="white--text drinkfont">Flavour Cappuccino</div>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg6 md8 sm12 xs12>
        <v-card>
          <v-container class="py-0 px-0" fluid>
            <v-row>
              <v-col
                v-for="document in Documents3()"
                :key="document.data().imageUrl"
                class="d-flex child-flex"
                cols="12"
              >
                <v-card flat tile>
                  <v-img
                    :src="document.data().imageUrl"
                    :lazy-src="document.data().imageUrl"
                    contain
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-flex>
    </v-row>
    <!-- end -->

    <!-- start 4 -->
    <v-row class="justify-center my-5">
      <v-flex lg6 md6 sm10 xs10>
        <div class="white--text drinkfont">Frappuccino</div>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg6 md8 sm12 xs12>
        <v-card>
          <v-container class="py-0 px-0" fluid>
            <v-row>
              <v-col
                v-for="document in Documents4()"
                :key="document.data().imageUrl"
                class="d-flex child-flex"
                cols="12"
              >
                <v-card flat tile>
                  <v-img
                    :src="document.data().imageUrl"
                    :lazy-src="document.data().imageUrl"
                    contain
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-flex>
    </v-row>
    <!-- end -->

    <!-- start 5 -->
    <v-row class="justify-center my-5">
      <v-flex lg6 md6 sm10 xs10>
        <div class="white--text drinkfont">Smoothie</div>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg6 md8 sm12 xs12>
        <v-card>
          <v-container class="py-0 px-0" fluid>
            <v-row>
              <v-col
                v-for="document in Documents5()"
                :key="document.data().imageUrl"
                class="d-flex child-flex"
                cols="12"
              >
                <v-card flat tile>
                  <v-img
                    :src="document.data().imageUrl"
                    :lazy-src="document.data().imageUrl"
                    contain
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-flex>
    </v-row>
    <!-- end -->

    <!-- start 6 -->
    <v-row class="justify-center my-5">
      <v-flex lg6 md6 sm10 xs10>
        <div class="white--text drinkfont">Soda Drink</div>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg6 md8 sm12 xs12>
        <v-card>
          <v-container class="py-0 px-0" fluid>
            <v-row>
              <v-col
                v-for="document in Documents6()"
                :key="document.data().imageUrl"
                class="d-flex child-flex"
                cols="12"
              >
                <v-card flat tile>
                  <v-img
                    :src="document.data().imageUrl"
                    :lazy-src="document.data().imageUrl"
                    contain
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-flex>
    </v-row>
    <!-- end -->

    <!-- start 7 -->
    <v-row class="justify-center my-5">
      <v-flex lg6 md6 sm10 xs10>
        <div class="white--text drinkfont">Coffee Liqueur</div>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg6 md8 sm12 xs12>
        <v-card>
          <v-container class="py-0 px-0" fluid>
            <v-row>
              <v-col
                v-for="document in Documents7()"
                :key="document.data().imageUrl"
                class="d-flex child-flex"
                cols="12"
              >
                <v-card flat tile>
                  <v-img
                    :src="document.data().imageUrl"
                    :lazy-src="document.data().imageUrl"
                    contain
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-flex>
    </v-row>
    <!-- end -->

    <!-- start 8 -->
    <v-row class="justify-center my-5">
      <v-flex lg6 md6 sm10 xs10>
        <div class="white--text drinkfont">Fresh Juice & Soft Drink</div>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg6 md8 sm12 xs12>
        <v-card>
          <v-container class="py-0 px-0" fluid>
            <v-row>
              <v-col
                v-for="document in Documents8()"
                :key="document.data().imageUrl"
                class="d-flex child-flex"
                cols="12"
              >
                <v-card flat tile>
                  <v-img
                    :src="document.data().imageUrl"
                    :lazy-src="document.data().imageUrl"
                    contain
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-flex>
    </v-row>
    <!-- end -->

    <!-- start 9 -->
    <v-row class="justify-center my-5">
      <v-flex lg6 md6 sm10 xs10>
        <div class="white--text drinkfont">Cocktail</div>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg6 md8 sm12 xs12>
        <v-card>
          <v-container class="py-0 px-0" fluid>
            <v-row>
              <v-col
                v-for="document in Documents9()"
                :key="document.data().imageUrl"
                class="d-flex child-flex"
                cols="12"
              >
                <v-card flat tile>
                  <v-img
                    :src="document.data().imageUrl"
                    :lazy-src="document.data().imageUrl"
                    contain
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-flex>
    </v-row>
    <!-- end -->

    <!-- start 10 -->
    <v-row class="justify-center my-5">
      <v-flex lg6 md6 sm10 xs10>
        <div class="white--text drinkfont">Aperitifs & Gin, Vodka</div>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg6 md8 sm12 xs12>
        <v-card>
          <v-container class="py-0 px-0" fluid>
            <v-row>
              <v-col
                v-for="document in Documents10()"
                :key="document.data().imageUrl"
                class="d-flex child-flex"
                cols="12"
              >
                <v-card flat tile>
                  <v-img
                    :src="document.data().imageUrl"
                    :lazy-src="document.data().imageUrl"
                    contain
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-flex>
    </v-row>
    <!-- end -->

    <!-- start 11 -->
    <v-row class="justify-center my-5">
      <v-flex lg6 md6 sm10 xs10>
        <div class="white--text drinkfont">Beer, Rum & Tequila, Liqueur</div>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg6 md8 sm12 xs12>
        <v-card>
          <v-container class="py-0 px-0" fluid>
            <v-row>
              <v-col
                v-for="document in Documents11()"
                :key="document.data().imageUrl"
                class="d-flex child-flex"
                cols="12"
              >
                <v-card flat tile>
                  <v-img
                    :src="document.data().imageUrl"
                    :lazy-src="document.data().imageUrl"
                    contain
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-flex>
    </v-row>
    <!-- end -->

    <!-- start 12 -->
    <v-row class="justify-center my-5">
      <v-flex lg6 md6 sm10 xs10>
        <div class="white--text drinkfont">Wine(Red Wine, White Wine)</div>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg6 md8 sm12 xs12>
        <v-card>
          <v-container class="py-0 px-0" fluid>
            <v-row>
              <v-col
                v-for="document in Documents12()"
                :key="document.data().imageUrl"
                class="d-flex child-flex"
                cols="12"
              >
                <v-card flat tile>
                  <v-img
                    :src="document.data().imageUrl"
                    :lazy-src="document.data().imageUrl"
                    contain
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-flex>
    </v-row>
    <!-- end -->

    <!-- start 13 -->
    <v-row class="justify-center my-5">
      <v-flex lg6 md6 sm10 xs10>
        <div class="white--text drinkfont">Whisky</div>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg6 md8 sm12 xs12>
        <v-card>
          <v-container class="py-0 px-0" fluid>
            <v-row>
              <v-col
                v-for="document in Documents13()"
                :key="document.data().imageUrl"
                class="d-flex child-flex"
                cols="12"
              >
                <v-card flat tile>
                  <v-img
                    :src="document.data().imageUrl"
                    :lazy-src="document.data().imageUrl"
                    contain
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-flex>
    </v-row>
    <!-- end -->

    <!-- start 14 -->
    <v-row class="justify-center my-5">
      <v-flex lg6 md6 sm10 xs10>
        <div class="white--text drinkfont">Whisky(Bourbon, Irish, Cognac)</div>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg6 md8 sm12 xs12>
        <v-card>
          <v-container class="py-0 px-0" fluid>
            <v-row>
              <v-col
                v-for="document in Documents14()"
                :key="document.data().imageUrl"
                class="d-flex child-flex"
                cols="12"
              >
                <v-card flat tile>
                  <v-img
                    :src="document.data().imageUrl"
                    :lazy-src="document.data().imageUrl"
                    contain
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-flex>
    </v-row>
    <!-- end -->

    <!-- start 15 -->
    <v-row class="justify-center my-5">
      <v-flex lg6 md6 sm10 xs10>
        <div class="white--text drinkfont">Whisky(Duty Free)</div>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg6 md8 sm12 xs12>
        <v-card>
          <v-container class="py-0 px-0" fluid>
            <v-row>
              <v-col
                v-for="document in Documents15()"
                :key="document.data().imageUrl"
                class="d-flex child-flex"
                cols="12"
              >
                <v-card flat tile>
                  <v-img
                    :src="document.data().imageUrl"
                    :lazy-src="document.data().imageUrl"
                    contain
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-flex>
    </v-row>
    <!-- end -->

    <!-- start 16 -->
    <v-row class="justify-center my-5">
      <v-flex lg6 md6 sm10 xs10>
        <div class="white--text drinkfont">Tai Kitchen's Corkage Charges, Bottle Charges</div>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg6 md8 sm12 xs12>
        <v-card>
          <v-container class="py-0 px-0" fluid>
            <v-row>
              <v-col
                v-for="document in Documents16()"
                :key="document.data().imageUrl"
                class="d-flex child-flex"
                cols="12"
              >
                <v-card flat tile>
                  <v-img
                    :src="document.data().imageUrl"
                    :lazy-src="document.data().imageUrl"
                    contain
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-flex>
    </v-row>
    <!-- end -->

  </v-container>
</template>
<script>
import Navbar from "@/components/Navbar.vue";

export default {
  components: {
    Navbar
  },
  methods: {
    Documents1() {
      return this.$store.getters.getDrink1;
    },
    Documents2() {
      return this.$store.getters.getDrink2;
    },
    Documents3() {
      return this.$store.getters.getDrink3;
    },
    Documents4() {
      return this.$store.getters.getDrink4;
    },
    Documents5() {
      return this.$store.getters.getDrink5;
    },
    Documents6() {
      return this.$store.getters.getDrink6;
    },
    Documents7() {
      return this.$store.getters.getDrink7;
    },
    Documents8() {
      return this.$store.getters.getDrink8;
    },
    Documents9() {
      return this.$store.getters.getDrink9;
    },
    Documents10() {
      return this.$store.getters.getDrink10;
    },
    Documents11() {
      return this.$store.getters.getDrink11;
    },
    Documents12() {
      return this.$store.getters.getDrink12;
    },
    Documents13() {
      return this.$store.getters.getDrink13;
    },
    Documents14() {
      return this.$store.getters.getDrink14;
    },
    Documents15() {
      return this.$store.getters.getDrink15;
    },
    Documents16() {
      return this.$store.getters.getDrink16;
    },
  },
  beforeCreate() {
    this.$store.commit("getDrink");
  },
  mounted(){
      window.scrollTo(0, 0);
  }

};
</script>
<style>

.bg {
  height: 100%;
}
.changefont {
  font-size: 2rem;
  font-weight: bold;
  color: white;
  margin-bottom: 10px;
}
.drinkfont {
  font-size: 1.5rem;
}
</style>